var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 2.25C3.82436 2.25 1.25 4.82436 1.25 8V20.9194C1.25 22.3868 2.94738 23.2026 4.09322 22.2859L6.92069 20.0239C7.14233 19.8466 7.41772 19.75 7.70156 19.75H17C20.1756 19.75 22.75 17.1756 22.75 14V8C22.75 4.82436 20.1756 2.25 17 2.25H7ZM7.0498 12.2998C7.74016 12.2998 8.2998 11.7402 8.2998 11.0498C8.2998 10.3594 7.74016 9.7998 7.0498 9.7998C6.35945 9.7998 5.7998 10.3594 5.7998 11.0498C5.7998 11.7402 6.35945 12.2998 7.0498 12.2998ZM13.2998 11.0498C13.2998 11.7402 12.7402 12.2998 12.0498 12.2998C11.3594 12.2998 10.7998 11.7402 10.7998 11.0498C10.7998 10.3594 11.3594 9.7998 12.0498 9.7998C12.7402 9.7998 13.2998 10.3594 13.2998 11.0498ZM17.0498 12.2998C17.7402 12.2998 18.2998 11.7402 18.2998 11.0498C18.2998 10.3594 17.7402 9.7998 17.0498 9.7998C16.3594 9.7998 15.7998 10.3594 15.7998 11.0498C15.7998 11.7402 16.3594 12.2998 17.0498 12.2998Z",
    fill: "#CAE9FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/Message.beb5a92c66d8d909ccd703aee9242876.svg";
export { ForwardRef as ReactComponent };